<template>
  <div v-bind:id="id" class="modal" v-bind:class="{active: showModal, narrow: narrow, pages: pages}" v-show="showModal">
    <div class="modal-header">
      <slot name="header"></slot>
      <a href="javascript:void(0)" class="btn-close modal-close" v-on:click="closeModal" v-bind:aria-label="closeButtonTitle"></a>
    </div>
    <div class="modal-body" v-bind:style="{'max-height': maxHeight + 'px'}">
      <slot name="body"></slot>
    </div>
    <div class="modal-footer" v-if="this.$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
  import VueTypes from 'vue-types'

  export default {
    name: 'ModalView',
    props: {
      id: VueTypes.string,
      isActive: false,
      narrow: VueTypes.bool.def(false),
      pages: VueTypes.bool.def(false),
      closeButtonTitle: VueTypes.string.def('この画面の説明を閉じる')
    },
    data () {
      return {
        showModal: false,
        // 画面を開く準備が出来たかどうか
        ready: false,
        // 画面が閉じられたかどうか
        closed: false,
        maxHeight: 0,
      }
    },
    mounted () {
      this.ready = this.isActive
      this.adjustHeight()
    },
    methods: {
      closeModal (stopPropagation) {
        this.showModal = false
        this.closed = true

        if (!stopPropagation) {
          this.$emit('close', this)
        }
      },
      adjustHeight () {
        if (this.showModal) {
          this.maxHeight = Math.min($(document).innerHeight() - 280, 600)
        }
      },
      setReady () {
        this.showModal = false
        this.ready = true
        this.closed = false
      }
    },
    watch: {
      showModal () {
        this.adjustHeight()
      },
    },
  }
</script>
